import React, { useState } from 'react'
import Specialcomp from './Features/Specialcomp'
import Add from './Features/Add';

export default function Specialadmincomp() {
    const [specialProducts, setSpecialProducts] = useState([]);

    const handleProductPosted = (newProduct) => {
        // Add the newly posted product to the list of special products
        setSpecialProducts((prevProducts) => [...prevProducts, newProduct]);
      };
  return (
    <div className='md:ml-10 ml-2 '>
      <Add onProductPosted={handleProductPosted} />

        <Specialcomp />
    </div>
  )
}
